import React, { useState, useEffect } from 'react';

const ProductDetailHero = ({ mainImage, alt }) => {
  const [currentImage, setCurrentImage] = useState(mainImage);

  useEffect(() => {
    setCurrentImage(mainImage);
  }, [mainImage]);

  return (
    <div className="w-full h-[300px] sm:h-[400px] md:h-[500px] lg:h-[700px] overflow-hidden bg-premium-light relative group">
      <img
        id="main-image"
        src={currentImage}
        alt={alt || "Product main image"}
        className="w-full h-full object-cover cursor-zoom-in transition-transform duration-500"
      />
      <button className="absolute top-4 right-4 w-12 h-12 bg-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" aria-label="Zoom image">
        <i className="fa-solid fa-magnifying-glass-plus text-premium-dark"></i>
      </button>
    </div>
  );
};

export default ProductDetailHero;
